<template>
    <div class="ibox form">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-4 col-sm-offset-2">
                    <a :href="returnBackRoute" class="btn btn-white btn-sm" data-cy="submit-btn-white-cancel">{{
                        __("cancel")
                    }}</a>
                    <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="checkClientDataExist('submit')"
                        data-cy="submit-btn-save"
                    >
                        {{ __("save") }}
                    </button>
                    <button
                        v-if="hasAccess == '1'"
                        type="button"
                        class="btn btn-primary btn-sm submit-and-redirect"
                        data-form-route="#"
                        @click="checkClientDataExist('submitAndRedirect')"
                        data-cy="submit-btn-save-edit"
                    >
                        {{ __("save_and_redirect_to_client_edit_form") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    props: {
        storeRoute: {
            type: String,
            default: "#"
        },
        storeAndRedirectRoute: {
            type: String,
            default: "#"
        },
        returnBackRoute: {
            type: String,
            default: "#"
        },
        hasAccess:{
            type: String,
            default: '0'
        }
    },
    methods: {
        checkClientDataExist(action) {
            let forms = document.querySelectorAll(".client-form");
            let formData = [];
            forms.forEach(element => {
                let data = {
                    name: element.querySelector('input[name="name[]"]').value,
                    idNumberType: element.querySelector(
                        'select[name="idNumberType[]"] option:checked'
                    ) != null ? element.querySelector(
                        'select[name="idNumberType[]"] option:checked'
                    ).value : null,
                    idNumber: element.querySelector('input[name="idNumber[]"]')
                        .value,
                    idNumberSecondaryType: element.querySelector(
                        'select[name="idNumberSecondaryType[]"] option:checked'
                    ) !== null ? element.querySelector(
                        'select[name="idNumberSecondaryType[]"] option:checked'
                    ).value : null,
                    idNumberSecondary: element.querySelector('input[name="idNumberSecondary[]"]')
                        .value,
                };
                formData.push(data);
            });

            this.checkUserDataExistInSystem(formData)
                .then(response => {
                    if (response.data.compaines.length > 0) {
                        this.dataExistModal(action, response.data.compaines);
                    } else {
                        this[action]();
                    }
                })
                .catch(error => {
                    toastr["error"](this.__("failed_to_perform_action")).css(
                        "border",
                        "0px"
                    );
                });
        },
        dataExistModal(action, companies) {
            let self = this;
            let companiesText = "";
            companies.forEach(company => {
                companiesText += `${company.clientName}, ${company.name} <br/>`;
            });
            let text = `${self.__(
                "the_user_entity_already_uses_cont_sup"
            )} <br/>  ${companiesText} ${self.__(
                "do_you_confirm_adding_a_second_user_with_the_same_id_number_?"
            )}`;
            this.$swal({
                title: self.__("warning_!"),
                html: text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#55dd82",
                confirmButtonText: self.capitalize(self.__("yes")),
                cancelButtonText: self.capitalize(self.__("no")),
                closeOnConfirm: true,
                reverseButtons: true
            }).then(result => {
                if (result.value == true) {
                    this[action]();
                }
            });
        },
        submit() {
            let form = document.getElementById("create-client-form");
            form.setAttribute("action", this.storeRoute);
            form.submit();
        },
        submitAndRedirect() {
            let form = document.getElementById("create-client-form");
            form.setAttribute("action", this.storeAndRedirectRoute);
            form.submit();
        },
        capitalize: function(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        ...mapActions(["checkUserDataExistInSystem"])
    }
};
</script>

<style lang="scss" scoped></style>

